import React from 'react';
import BranchDetailsForm from './BranchDetailsForm';
import ServiceSettingsForm from './ServiceSettingsForm';
import { F } from '@/utils/intl';

// Branch details panel
const BranchDetailsPanel = ({ branch, onSuccess }: { branch: any; onSuccess?: (data: any) => void }) => (
  <div style={{ padding: '0 12px' }}>
    <BranchDetailsForm branch={branch} onSuccess={onSuccess} />
  </div>
);

// Service settings panel
const ServiceSettingsPanel = ({ serviceId, branch, onSuccess }: { serviceId: string; branch: any; onSuccess?: (data?: any) => void }) => {
  const services = branch?.services || branch?.branch_services || [];
  const service = services.find((s: any) => (s.id || s.uuid) === serviceId);

  if (!service) return (
    <div>
      <F id="pages.locations.serviceNotFound" defaultMessage="Service not found" />
    </div>
  );

  return (
    <div style={{ padding: '0 12px' }}>
      <ServiceSettingsForm service={service} branch={branch} onSuccess={onSuccess} />
    </div>
  );
};

export const getPanel = (selectedNavItem: string | number, branch: any, onSuccess?: (data: any) => void) => {
  if (selectedNavItem === 'details') {
    return <BranchDetailsPanel branch={branch} onSuccess={onSuccess} />;
  }
  if (typeof selectedNavItem === 'string') {
    return <ServiceSettingsPanel serviceId={selectedNavItem} branch={branch} onSuccess={onSuccess} />;
  }
  return (
    <div>
      <F id="pages.locations.selectItemFromSidebar" defaultMessage="Select an item from the sidebar" />
    </div>
  );
};
